module.exports = __webpack_public_path__ + "assets/img/D1.2f32a97e.jpg";